export default {

    route: {
        register: 'register',
        editorNotice: 'Editor Notice',
        previewNotice: 'Preview Notice',
        tenderList: 'Tender List',
        mipIframe: 'MIP Iframe',
        tenderDetails: 'Tender Details',
        payBidDetail: 'Pay BidDetail',
        payFreight: 'Pay Freight',
        refundApplication: 'Refund Application',
        supAnnoList: 'SupAnnoList',
        supPreviewNotice: 'SupPreview Notice',
        myBidding: 'My Bidding',
        tenderCost: 'Tender Cost',
        tendermanagement: 'Tender Management',
        tenderdocument: 'Tender Document',
        supplierbid: 'Supplier Bidding Management',
        graderesult: 'Comprehensive scoring results',
        roundquote: 'Round Quotation',
        tenderresult: 'Tender Result',
        tendertemplate: 'Tender Template',
        templatedetails: 'Tender template details',
        comprehensivegrade: 'Comprehensive Marking',
        baseConfig: 'Type Configuration',
        keyData: 'Supplier Master Data',
        mipMessage: 'Approval Details',
        accountManage: 'Account Management',
        driverInfo: 'Driver Management',
        personInfo: 'Personnel Account Management',
        vehicleInfo: 'Vehicle Management',
        contractUphold: 'Contract Maintenance',
        warningConfigure: 'Early Warning Configuration',
        warningTask: 'Early Warning Task',
        contractSigning: 'Contract Signing',
        fileConfiguration: 'File Configuration',
        payfileConfiguration: 'Term of Payment',
        keyDataDetail: 'Supplier Details',
        mipExamine: 'Change Approval',
        basicInfo: 'Basic Information',
        warehouseInfo: 'Warehouse Management',
        wtMipIframe: 'Early Warning Task',
        cuMipIframe: 'Contract Maintenance Process Approval',
        toDolist: 'Template To Do',
        toDodetails: 'To Do Template Details',
        toDoLesseeList: 'Tenant Template Mapping',
        toDoLesseeDe: 'Tenant Template Details',
        toDoItems: 'To Do List',
        toDoItemsDeitails: 'To Do Details',
        myTender: 'Quotation Details',
        costDetail: 'Quotation Details',
        addPhysicalStorage: 'New physical warehouse',
        physicalStorage: 'Physical Storage',
        blackDriverMIP: 'Supplier Driver Pull Black MIP Approval',
        dailyAssessment: 'Daily Assessment',
        rectificationTask: 'Rectification Task',
        monthlyAssessment: 'Monthly Assessment',
        monthlyAssessScore: 'Monthly Assessment Score',
        rushOrderAuthApply: 'Rush Order Auth Apply',
        driverAddSupplier: 'Driver Add Supplier',
        driverDelegateLetter: 'Driver Delegate Letter',
        legalPerform: 'Legal Perform',
        performRectify: 'Perform Rectify',
        warehouseDelegationLetter: 'Warehouse Delegation Letter',
        warehouseDelegationApprove: 'Warehouse Delegation Approve',
        loaderSalaryConfirm: 'Loader Salary Confirm',
        performanceAdjustment: 'Performance Adjustment',
        abnormalAssess: 'Abnormal Assess',
        idleResource: 'Idle Resource',
    }
};
